module.exports = global["Components"] = require("-!D:\\a\\1\\s\\Brilleland.Frontend\\node_modules\\babel-loader\\lib\\index.js!.\\app.components.js");